// eslint-disable-next-line import/prefer-default-export
export const isEnterOrSpace = (event: React.KeyboardEvent) => {
  return (
    event.keyCode === 13 ||
    event.code === "Enter" ||
    event.keyCode === 32 ||
    event.code === "Space"
  );
};

/**
 * @param imgSrc
 * @returns src with url blocked by OneTrust replaced
 */
export const getOneTrustSafeImgSrc = (imgSrc: string) => {
  return typeof imgSrc === "string"
    ? imgSrc.replace("img.youtube.com", "i.ytimg.com")
    : imgSrc;
};

export const getCorrectPlatform = (
  platformShortName: string,
  originalSource: string
) => {
  let correctPlatform;
  if (platformShortName === "w") correctPlatform = "web";
  if (platformShortName === "v") correctPlatform = "vhost";
  if (!platformShortName) correctPlatform = originalSource;
  return correctPlatform;
};

export const getRegFormType = (isCif: boolean) => (isCif ? "CIF" : "Legacy");

export const checkIsTrailsEnabled = (trailsCount: number) => trailsCount > 0;

export const checkIsDestinationsViewActive = (view: string) =>
  view === "destinations";

export const checkIsTrailsViewActive = (view: string) => view === "trails";

export const checkIsDirectionsViewActive = (view: string) =>
  view === "directions";

/* eslint-disable no-param-reassign */
export const distanceBetweenPoints = (lat1, lon1, lat2, lon2) => {
  const degToRad = (deg) => {
    return (deg * Math.PI) / 180;
  };

  const R = 6371; // earth's mean radius in km
  const dLat = degToRad(lat2 - lat1);
  const dLon = degToRad(lon2 - lon1);

  lat1 = degToRad(lat1);
  lat2 = degToRad(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;

  return 1000 * d;
};
